export const DELEGATE_TABLE_COLUMNS = [
  "companyName",
  "accountNumber",
  "type",
  "updatedTs",
] as const;

export const CELL_WIDTH = {
  companyName: "25%",
  accountNumber: "25%",
  type: "25%",
  updatedTs: "25%",
} as const;

export const TID_DELEGATE_TYPE_LABEL_KEY: Record<string, string> = {
  DEFAULT_DELEGATE: "companies.tid.delegate.types.default",
  CUSTOM_DELEGATE: "companies.tid.delegate.types.custom",
};
